/**
 * Tower poison (The Fungi Forest's Poison Shroom; spec
 * 2026-10-20-fungi-forest-design.md): a dose that lands for nothing, then
 * takes `damage` HP every `every` seconds, `ticks` times. Pure — the sim
 * owns the tower and routes each tick's damage through its own hurtTower,
 * so a poison kill frees the plot exactly as a fireball kill does.
 *
 * A second dose while poisoned REPLACES the first (a refresh), never stacks.
 * A poisoned tower keeps attacking: this is damage only.
 */

export interface TowerPoisonSpec {
  damage: number;
  ticks: number;
  every: number;
}

export interface TowerPoison {
  /** Ticks still to land. */
  left: number;
  /** Seconds until the next tick. */
  nextIn: number;
  damage: number;
  every: number;
}

/** Float slack, so sixty 1/60 s steps count as a whole second. */
const EPS = 1e-6;

export function applyTowerPoison(spec: TowerPoisonSpec): TowerPoison {
  return { left: spec.ticks, nextIn: spec.every, damage: spec.damage, every: spec.every };
}

/** Advance a dose by `dt`; returns the damage due now and whether it has run out. */
export function tickTowerPoison(p: TowerPoison, dt: number): { damage: number; done: boolean } {
  p.nextIn -= dt;
  let damage = 0;
  while (p.left > 0 && p.nextIn <= EPS) {
    damage += p.damage;
    p.left--;
    p.nextIn += p.every;
  }
  return { damage, done: p.left <= 0 };
}
